import { Wrapper } from "./components";

function SettingsGroupWrapper({ children }) {
  return <Wrapper variant="outlined">{children}</Wrapper>;
}

export { SettingsGroupWrapper };
